/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ImageLoader from "./ImageLoader";
import Scroller from "./Scroller";
import TurnIcon from "./TurnIcon";

export const easeOutBack = (t, b, c, d, s) => {
  // t: current time, b: begInnIng value, c: change In value, d: duration
  console.log(t,b,c,d,s)
  if (s === undefined) s = 1.70158;
  return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
};

export const ImageSlider = (props) => {
  const { t } = useTranslation();
  const { width, height, image, text, textColor } = props;
  const [active, setActive] = useState(false);
  const [perspective, setPerspective] = useState(
    image.front ? "front" : "back"
  );
  const [dimensions, setDimensions] = useState({ width, height });
  const [imgWidth, setImgWidth] = useState(400);
  const [isVisible, setIsVisible] = useState(false);
  const scroller = useRef();
  const wrapper = useRef();
  const after = useRef();

  useEffect(() => {
    document.body.addEventListener("mouseup", () => setActive(false));
    document.body.addEventListener("mouseleave", () => setActive(false));
    document.body.addEventListener("touchend", () => setActive(false));
    document.body.addEventListener("touchcancel", () => setActive(false));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      });
    });

    observer.observe(wrapper.current);

    return () => {
      observer.unobserve(wrapper.current);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      animateScroller();
    }
  }, [isVisible]);

  const animateScroller = () => {
    const finishPoint = wrapper.current.offsetWidth/2;
    const startingPoint = wrapper.current.offsetWidth/3;
    const wrapperWidth = wrapper.current.offsetWidth;
    const maxScroll = wrapperWidth;
    //console.log(maxScroll)
    const animationDuration = 100; // Adjust the duration as needed

    const animateLeft = () => {
      const animationStep = maxScroll / animationDuration;
      let currentScroll = startingPoint;
      
      
      const scrollLeft = () => {
        currentScroll += animationStep;
        const easing = 1 - Math.pow(1 - currentScroll / maxScroll, 2);
        // t: current time, b: begInnIng value, c: change In value, d: duration
        const moving = easeOutBack(currentScroll, startingPoint, maxScroll, animationDuration);
        //console.log(moving, currentScroll)
        console.log(easing);
        if (currentScroll <= maxScroll) {
          after.current.style.width = currentScroll * easing + "px";
          scroller.current.style.left = currentScroll * easing - 25 + "px";
          requestAnimationFrame(scrollLeft);
        } else {
          animateRight();
        }
      };

      scrollLeft();
    };

    const animateRight = () => {
      const animationStep = maxScroll / animationDuration;
      let currentScroll = maxScroll;
      const scrollRight = () => {
        currentScroll -= animationStep;
        const easing = 1 - Math.pow(1 - currentScroll / finishPoint, 2);
        if (currentScroll >= finishPoint) {
          after.current.style.width = currentScroll * easing + "px";
          scroller.current.style.left = currentScroll * easing - 25 + "px";
          requestAnimationFrame(scrollRight);
        } else {
          scrollIt(finishPoint);
        }
      };

      scrollRight();
    };
    scrollIt(maxScroll);
    animateRight();
  };

  useEffect(() => {
    scrollIt(imgWidth / 2);
  }, [imgWidth]);

  const onMouseMove = (e) => {
    if (!active) return;
    let x = e.pageX ? e.pageX : e.changedTouches[0].pageX;
    x -= wrapper.current.getBoundingClientRect().left;
    scrollIt(x);
  };

  const moveElement = (e) => {
    let x = e.pageX ? e.pageX : e.changedTouches[0].pageX;
    x -= wrapper.current.getBoundingClientRect().left;
    scrollIt(x);
  };

  const scrollIt = (x) => {
    let transform = Math.max(0, Math.min(x, wrapper.current.offsetWidth));
    after.current.style.width = transform + "px";
    scroller.current.style.left = transform - 25 + "px";
  };

  const isReverseEnabled = () => {
    if (image.front && image.back) return true;
    return false;
  };

  const onImgLoad = ({ target: img }) => {
    setImgWidth(img.clientWidth);
    setDimensions({
      height: `${img.clientHeight}px`,
      width: `${img.clientWidth}px`,
    });
  };

  const scrollerProps = {
    elRef: scroller,
    onMouseDown: (e) => {
      e.preventDefault();
      wrapper.current.addEventListener("mousemove", moveElement, false);
    },
    onTouchStart: (e) => {
      setActive(true);
    },
    onMouseUp: (e) => {
      wrapper.current.removeEventListener("mousemove", moveElement, false);
      setActive(false);
    },
    onTouchEnd: (e) => {
      setActive(false);
    },
    active,
  };

  return (
    <div
      id="page"
      className="container"
      onMouseMove={onMouseMove}
      onTouchMove={onMouseMove}
    >
      <div
        ref={wrapper}
        className="wrapper"
        style={{
          display: "flex",
          width: `${dimensions.width}`,
          height: `${dimensions.height}`,
        }}
      >
        <ImageLoader
          onLoad={onImgLoad}
          classname="after"
          alt={"After"}
          image={image[perspective].after}
          text={text && t("AFTER")}
          textColor={textColor}
        />

        <ImageLoader
          imgRef={after}
          classname="before"
          alt={"Before"}
          image={image[perspective].before}
          text={text && t("BEFORE")}
          textColor={textColor}
        />
        <Scroller {...scrollerProps} />
        {isReverseEnabled() && (
          <TurnIcon
            onClick={() =>
              setPerspective(perspective === "front" ? "back" : "front")
            }
          />
        )}
      </div>
    </div>
  );
};

ImageSlider.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  image: PropTypes.object,
  text: PropTypes.bool,
  textColor: PropTypes.string,
};

ImageSlider.defaultProps = {
  textColor: "black",
};
